import { ensureNoUndefinedProperties } from '@/Shared/Helper/EnsureNoUndefinedProperties'

export default class BusinessNameGeneratorSessionID {
    constructor(public readonly value: number) {
        ensureNoUndefinedProperties(this)
    }
}
